import { testimonials } from "@/mocks/mangaData";

export default function Testimonials() {
  return (
    <section id="voice" className="py-12 md:py-20 bg-background-50">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="text-center max-w-2xl mx-auto mb-8 md:mb-12">
          <span className="inline-flex items-center gap-1.5 text-primary-600 text-sm font-medium">
            <i className="ri-quote-text"></i>
            用户口碑
          </span>
          <h2 className="mt-2 font-display text-2xl md:text-4xl text-foreground-950">
            他们也在这里找到本命
          </h2>
          <p className="mt-2 text-sm md:text-base text-foreground-600">
            无数读者通过本命推荐入坑，找到了值得一生推的那部作品。
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {testimonials.map((t) => (
            <figure
              key={t.id}
              className="flex flex-col p-5 rounded-xl bg-background-100/70 border border-background-200/70 hover:border-accent-300 transition-colors"
            >
              <div className="flex items-center gap-1 text-accent-500 mb-3">
                {Array.from({ length: 5 }).map((_, i) => (
                  <i key={i} className="ri-star-fill text-sm"></i>
                ))}
              </div>
              <blockquote className="flex-1 text-sm text-foreground-700 leading-relaxed">
                “{t.text}”
              </blockquote>
              <figcaption className="mt-4 flex items-center gap-3 border-t border-background-200/70 pt-3">
                <img
                  src={t.avatar}
                  alt={`${t.name}的读者头像`}
                  title={`${t.name}的读者口碑`}
                  className="w-10 h-10 rounded-full object-cover object-top"
                />
                <div>
                  <div className="text-sm font-medium text-foreground-900">{t.name}</div>
                  <div className="text-xs text-foreground-500">{t.role}</div>
                </div>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}